export default {
      id: "keyboard_arrow_left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#keyboard_arrow_left",
      toString: function () {
        return this.url;
      }
    }